import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { slidesTestimonail } from '../utilities/constant';


const Testimonial = () => {
  return <div className="section techwix-testimonial-section-02 techwix-testimonial-section-03 section-padding-02">
    <div className="container">
      {/* <!-- Testimonial Wrap Start  --> */}
      <div className="testimonial-wrap-02">
        <div className="section-title text-center">
          <h3 className="sub-title">Testimonial</h3>
          <h2 className="title">50+ satisfied clients worldwide</h2>
        </div>
        <div className="testimonial-content-wrap-02">
          <div className="swiper-container testimonial-02-active">
            <Swiper
              // slidesPerView={2}
              // spaceBetween={30}
              loop={true} // 👈 This enables infinite loop
              pagination={{ dynamicMainBullets: true }}
              modules={[Pagination]}
              // className="case-swiper"
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },

                1401: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
              }}
            >
              {slidesTestimonail.map((slide, i) => (
                <SwiperSlide key={slide.id}>
                  <div className="single-testimonial-02">
                    <div className="testimonial-thumb">
                      <img src={slide.image} alt="66" />
                    </div>
                    <div className="testimonial-content">
                      <img src={slide.icon} alt="icon" />
                      <p>{slide.description} </p>
                      <span className="name">{slide.name} </span>
                      <span className="designation">
                        {" "}
                        / {slide.designation}
                      </span>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
      {/* <!-- Testimonial Wrap End  --> */}
    </div>
  </div>;
}


export default Testimonial;